var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sale-duration",style:({
    color: _vm.mainTextColor,
  })},[_vm._v("\n  "+_vm._s(_vm.$tc('day', _vm.duration.days(), { days: _vm.duration.days() }))+"\n  "+_vm._s(String(_vm.duration.hours()).padStart(2, '0'))+":"+_vm._s(String(_vm.duration.minutes()).padStart(2, '0'))+":"+_vm._s(String(_vm.duration.seconds()).padStart(2, '0'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }